
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'OxdBranding',

  props: {
    url: {
      type: String,
      required: false,
      default: '/',
    },
    logoSrc: {
      type: String,
      required: false,
      default: '',
    },
    bannerSrc: {
      type: String,
      required: false,
      default: '',
    },
    toggle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
  },
});
